




































































































































































































import { Component, Mixins } from 'vue-property-decorator'
import DexieService from '@/services/dexie-service'
import { Sync } from '@/interfaces/Sync'
import axios from 'axios'
import SnackbarService from '@/services/snackbar-service'
import moment from 'moment-timezone'
import AuthService from '@/services/auth-service'

@Component({
  components: {},
})
export default class SettingsAddCols extends Mixins(
  DexieService,
  SnackbarService,
  AuthService
) {
  // edit select
  editListDialogColDefId = null
  editListDialogSelectIsOpen = false
  editListDialogSelectSettingColName = ''
  editDetailsSelectDialogIsOpen = false
  newSelectSettingValue = ''
  editDetailsDeleteDialogIsOpen = false
  editDialogUpdateColNameIsOpen = false

  settingValeToUpdate = ''
  upateSelectSettingId = 0
  deleteAlternativeId: any = null
  newColName = ''
  oldColName = ''

  openListEditDialogCols(colDef: any) {
    if (colDef.type === 'select') {
      this.editListDialogSelectIsOpen = true
      this.editListDialogColDefId = colDef.id
      this.editListDialogSelectSettingColName = colDef.name
    } else {
      this.openDetailsEditColNameNonSelectSettings(colDef)
    }
  }

  updateSelectSettingValue = ''

  openDetailsEditSettings(selectSettingItem: any) {
    this.setSelectSettingItem(selectSettingItem)
    this.editDetailsSelectDialogIsOpen = true
  }

  openDetailsDeleteSelectSettings(selectSettingItem: any) {
    this.deleteAlternativeId = ''
    this.setSelectSettingItem(selectSettingItem)
    this.editDetailsDeleteDialogIsOpen = true
  }

  setSelectSettingItem(selectSettingItem: any) {
    this.updateSelectSettingValue = selectSettingItem.value
    this.settingValeToUpdate = selectSettingItem.value
    this.upateSelectSettingId = selectSettingItem.id
  }

  postSelectSetting() {
    const payload = {
      value: this.newSelectSettingValue,
      col_def_id: this.editListDialogColDefId,
    }
    axios.post('add-select-col-option', payload).then((res: any) => {
      this.updateAccount()
      this.newSelectSettingValue = ''
      this.notify({ text: 'Added successfully', type: 'success' })
    })
  }

  updateColName() {
    const payload = {
      name: this.newColName,
    }
    axios
      .patch(`add-col-def/${this.editListDialogColDefId}`, payload)
      .then((res: any) => {
        this.updateAccount()
        this.editListDialogSelectSettingColName = this.newColName
        this.editDialogUpdateColNameIsOpen = false
        this.notify({ text: 'Added successfully', type: 'success' })
      })
  }

  deleteSetting() {
    axios
      .delete(
        `add-select-col-option/${this.upateSelectSettingId}/${this.deleteAlternativeId}`
      )
      .then((res: any) => {
        this.updateAccount()
        //this.editDetailsDialogIsOpen = false
        this.editDetailsDeleteDialogIsOpen = false
        this.notify({ text: 'Deleted successfully', type: 'success' })
      })
  }

  openDetailsEditColNameSelectSettings() {
    this.editDialogUpdateColNameIsOpen = true
    this.oldColName = this.editListDialogSelectSettingColName
    this.newColName = this.editListDialogSelectSettingColName
  }

  openDetailsEditColNameNonSelectSettings(colDef: any) {
    this.editDialogUpdateColNameIsOpen = true
    this.editListDialogColDefId = colDef.id
    this.oldColName = colDef.name
    this.newColName = colDef.name
  }

  openDetailsEditSelectSettings(selectSettingItem: any) {
    this.setSelectSettingItem(selectSettingItem)
    this.editDetailsSelectDialogIsOpen = true
  }

  updateSelectSetting() {
    const payload = {
      value: this.updateSelectSettingValue,
      col_def_id: this.editListDialogColDefId,
    }
    axios
      .patch(`add-select-col-option/${this.upateSelectSettingId}`, payload)
      .then((res: any) => {
        this.updateAccount()
        this.editDetailsSelectDialogIsOpen = false
        this.editDetailsDeleteDialogIsOpen = false
        this.notify({ text: 'Updated successfully', type: 'success' })
      })
  }

  delteColDefDialogIsOpen = false
  colDefToDelete = null
  openDeleteColDef(colDef: any) {
    this.colDefToDelete = colDef
    this.delteColDefDialogIsOpen = true
  }

  deleteColDef() {
    axios.delete(`add-col-def/${this.colDefToDelete.id}`).then((res: any) => {
      this.updateAccount()
      this.colDefToDelete = null
      this.delteColDefDialogIsOpen = false
      this.notify({ text: 'Deleted successfully', type: 'success' })
    })
  }

  get alreadyExistsErrorAdd() {
    if (!this.$store.state.account || !this.newSelectSettingValue) {
      return false
    }
    return this.$store.state.account.add_col_options
      .filter(o => o.col_def_id === this.editListDialogColDefId)
      .map(i => i.value)
      .includes(this.newSelectSettingValue)
  }

  get alreadyExistsMessageAdd() {
    return this.alreadyExistsErrorAdd ? 'Already exists' : ''
  }

  get alreadyExistsErrorUpdate() {
    if (!this.$store.state.account || !this.updateSelectSettingValue) {
      return false
    }
    return this.$store.state.account.col_defs
      .map(i => i.name)
      .filter(n => n !== this.settingValeToUpdate)
      .includes(this.updateSelectSettingValue)
  }

  get alreadyExistsMessageUpdate() {
    return this.alreadyExistsErrorUpdate ? 'Already exists' : ''
  }

  get alreadyExistsErrorColName() {
    if (!this.$store.state.account || !this.updateSelectSettingValue) {
      return false
    }
    return this.$store.state.account.col_defs
      .map(i => i.name)
      .filter(n => n !== this.oldColName)
      .includes(this.newColName)
  }

  get alreadyExistsMessageColName() {
    return this.alreadyExistsErrorColName ? 'Already exists' : ''
  }

  get alreadyExistsErrorAddNewCol() {
    if (!this.$store.state.account || !this.addColNewName) {
      return false
    }
    return this.$store.state.account.col_defs
      .map(i => i.name)
      .filter(n => n !== this.oldColName)
      .includes(this.addColNewName)
  }

  get alreadyExistsMessageAddNewCol() {
    return this.alreadyExistsErrorAddNewCol ? 'Already exists' : ''
  }

  get colDefs() {
    return this.$store.state.account.col_defs.sort((c1: any, c2: any) =>
      c1.name < c2.name ? -1 : 1
    )
  }

  // add col def
  addColDefRadio = 'select'
  addColDefDialogIsOpen = false
  addColNewName = ''

  sendAddColDef() {
    const payload = {
      name: this.addColNewName,
      type: this.addColDefRadio,
    }
    axios.post(`add-col-def`, payload).then((res: any) => {
      this.updateAccount()
      this.addColDefDialogIsOpen = false
      this.notify({ text: 'ADded successfully', type: 'success' })
    })
  }
  get alreadyExistsErrorAddColName() {
    if (!this.$store.state.account) {
      return false
    }
    return this.$store.state.account.col_defs
      .map(i => i.name)
      .includes(this.addColNewName)
  }

  get alreadyExistsMessageAddColName() {
    return this.alreadyExistsErrorColName ? 'Already exists' : ''
  }
}
